import React, { useState } from 'react'
import Title from '../layouts/Title';
import Education from './Education';
import Skills from './Skills';

const Resume = () => {
  const [educationData, setEducationData] = useState(true);
  const [skillData, setSkillData] = useState(false);
  return (
    <section id="resume" className="w-full mx-auto py-20 border-b-[1px] dark:border-b-gray-600">
      <div className="flex justify-center items-center text-center">
        <Title title="EXPERIENCE" des="My Resume" />
      </div>
      <div>
        <ul className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2">
          <li
            onClick={() =>
              setEducationData(true) &
              setSkillData(false)
            }
            className={`${educationData
              ? "dark:border-designColor border-blue-600 rounded-lg"
              : "border-transparent"
              } resumeLi`}
          >
            Experience
          </li>
          <li
            onClick={() =>
              setEducationData(false) &
              setSkillData(true)
            }
            className={`${skillData ? "dark:border-designColor border-blue-600 rounded-lg" : "border-transparent"
              } resumeLi`}
          >
            Professional Skills
          </li>
        </ul>
      </div>
      {educationData && <Education />}
      {skillData && <Skills />}

    </section>
  );
}

export default Resume